import { connect } from 'react-redux'
import type { Dispatch } from 'redux'
import type { TransformForm } from 'shared/store/kingdom/points'
import {
    resetTransformPoints,
    transformPoints,
    untransformPoints
} from 'shared/store/kingdom/points'
import { OfferComponent } from './OfferComponent'
import type { RootState } from 'shared/store/reducers'
import type { EventMetadata } from 'shared/store/metadata'
import { eventMetadata } from 'shared/store/metadata'
import { go, push } from 'connected-react-router'
import { fetchPrivilegesPageData } from 'shared/store/kingdom/privileges'
import type { CacPromotion, Coupon } from 'shared/types'
import { processCouponNavigation } from 'shared/store/ecommerce/order'
import { featureCodes } from 'shared/utils'

const mapStateToProps = (state: RootState) => {
    const { transformPointsError } = state.kingdomPointsPageState
    const { promotionsById } = state.ecommerceCatalogState
    const { collectMode } = state.ecommerceOrderState
    const isActiveNewKingdomAssets =
        state.featuresState.available.includes(
            featureCodes.ENABLE_NEW_KINGDOM_ASSETS
        ) ?? false
    return {
        transformPointsError,
        promotionsById,
        collectMode,
        isActiveNewKingdomAssets
    }
}

const mapDispatchToProps = (d: Dispatch<any>) => ({
    transformPoints: (form: TransformForm) => d(transformPoints(form)),
    untransformPoints: (couponId: string) => d(untransformPoints(couponId)),
    resetTransformPoints: () => d(resetTransformPoints()),
    sendMeta: (meta: EventMetadata) => d(eventMetadata(meta)),
    fetchPrivilegesData: () => d(fetchPrivilegesPageData()),
    processCouponNavigation: (coupon: Coupon, promotion: CacPromotion) =>
        d(processCouponNavigation(coupon, promotion)),
    navigation: (to: string, state?: any, refresh?: boolean) => {
        if (refresh) {
            d(
                go({
                    pathname: to,
                    state
                })
            )
        }
        d(
            push({
                pathname: to,
                state
            })
        )
    }
})

const Offer = connect(mapStateToProps, mapDispatchToProps)(OfferComponent)

export { Offer }
